export default __webpack_public_path__ + "static/media/Level37.b67b78f9.svg";